import styled from "@emotion/styled";

export const ScreenContainer = styled.div`
  height: 100%;
  padding: 0 2rem;
  overflow: hidden;
`;
export const Headers = styled.div``;
export const FilesHeader = styled.div`
display:grid;
grid-template-columns: 50% 50%;

`;
export const H1 = styled.h1`
  padding: 30px 0px;
  margin-top: 30px;
  text-align: left;
`;
export const H3 = styled.h3`
  padding: 20px 0px;
  text-align: left;
`;

export const BtnsContainer = styled.div`
display:grid;

grid-auto-rows: min-content;
gap:2rem;
margin-top:50px;
justify-self: flex-end;

`;
export const DeleteBtn = styled.button`

justify-self: flex-end;

  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  
`;
export const RenameBtn = styled.button`

justify-self: flex-end;

  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  
`;

export const Files = styled.div`
  background-color: transparent;
  margin-top: 70px;
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(6, 1fr);
`;

export const singleFile = styled.div`
  align-items: center;
  border: 1px solid #000;
  border-radius: 20px;
  box-shadow: none;
`;
export const LogoContainer = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
`;
export const LogoImage = styled.img`
  height: 180px;
  width: 180px;
  margin-top: 10px;
`;
export const H4 = styled.h4`
  text-align: center;
  margin-top: 10px;
`;
